import { useState } from "react";
import "@/App.css";
import { SplashScreen } from "./components/SplashScreen";
import { Header } from "./components/Header";
import { HeroSlider } from "./components/HeroSlider";
import { FeatureBoxes } from "./components/FeatureBoxes";
import { AboutSection } from "./components/AboutSection";
import { ServicesSection } from "./components/ServicesSection";
import { ProductsSection } from "./components/ProductsSection";
import { CalculatorSection } from "./components/CalculatorSection";
import { PartnersSection } from "./components/PartnersSection";
import { ProcessSection } from "./components/ProcessSection";
import { AchievementsSection } from "./components/AchievementsSection";
import { TestimonialsSection } from "./components/TestimonialsSection";
import { FaqSection } from "./components/FaqSection";
import { EnquirySection } from "./components/EnquirySection";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";

function App() {
  const [splashDone, setSplashDone] = useState(false);

  return (
    <div className="App relative" data-testid="app-root">
      {/* Splash Screen */}
      {!splashDone && <SplashScreen onComplete={() => setSplashDone(true)} />}

      {/* Watermark Logo - 30% opacity */}
      <div className="fixed inset-0 z-0 pointer-events-none flex items-center justify-center opacity-[0.30]">
        <img
          src="https://customer-assets.emergentagent.com/job_financial-evolution-1/artifacts/o920clpu_Ashwamedh%20Logo%20-%201.png"
          alt=""
          className="w-[500px] h-auto"
        />
      </div>

      <div className="relative z-10">
        <Header />
        <HeroSlider />
        <FeatureBoxes />
        <AboutSection />
        <ServicesSection />
        <ProductsSection />
        <CalculatorSection />
        <PartnersSection />
        <ProcessSection />
        <AchievementsSection />
        <TestimonialsSection />
        <FaqSection />
        <EnquirySection />
        <Footer />
        <WhatsAppButton />
      </div>
    </div>
  );
}

export default App;
